var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"swap-router-wrapper"}},[_c('NavMenu'),_c('SwapFormMain',{attrs:{"token-list":_vm.tokenList}}),_c('SwapFormFoot',{attrs:{"token-list":_vm.tokenList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }